import { useSyncExternalStore, useCallback } from 'react';
import UndoManager from '../undoManager';

/**
 * Undo/redo state and actions for a case.
 * Subscribes to the UndoManager so buttons enable/disable live.
 */
export function useUndoRedo(caseId) {
  useSyncExternalStore(UndoManager.subscribe, UndoManager.getVersion);

  const undo = useCallback(() => UndoManager.undo(caseId), [caseId]);
  const redo = useCallback(() => UndoManager.redo(caseId), [caseId]);

  return {
    canUndo: UndoManager.canUndo(caseId),
    canRedo: UndoManager.canRedo(caseId),
    undoLabel: UndoManager.peekUndoLabel(caseId),
    redoLabel: UndoManager.peekRedoLabel(caseId),
    undo,
    redo,
  };
}

export default useUndoRedo;
